import Page from 'modules/Contacts'

export default Page

